import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccAssets = {
    advanceBookingPeriodNotificationIconName: 'clock-solid',
    carouselNextButtonIconName: 'chevron-right',
    carouselPreviousButtonIconName: 'chevron-left',
    componentErrorIconName: 'generic-error-message',
    expandContentIndicatorIconName: 'chevron-down',
    filmWatchlistButtonIconName: 'bookmark',
    loadingIconName: 'spinner',
    modalCloseButtonIconName: 'cross',
    notificationCloseButtonIconName: 'cross',
    notificationErrorIconName: 'warning-circle',
    notificationInfoIconName: 'speech-circle',
    notificationSuccessIconName: 'check-circle',
    notificationWarningIconName: 'warning-circle',
    passwordInputHiddenIconName: 'eye',
    passwordInputVisibleIconName: 'eye-with-diagonal-line',
    passwordRuleCheckerInitialIconName: 'bullet-point',
    passwordRuleCheckerInvalidIconName: 'cross',
    passwordRuleCheckerSuccessIconName: 'check'
};
export const occAssetsValidator = Validator.object({
    advanceBookingPeriodNotificationIconName: Validator.optional(nonEmptyStringValidator),
    carouselNextButtonIconName: nonEmptyStringValidator,
    carouselPreviousButtonIconName: nonEmptyStringValidator,
    componentErrorIconName: nonEmptyStringValidator,
    expandContentIndicatorIconName: nonEmptyStringValidator,
    filmWatchlistButtonIconName: nonEmptyStringValidator,
    loadingIconName: nonEmptyStringValidator,
    modalCloseButtonIconName: nonEmptyStringValidator,
    notificationCloseButtonIconName: nonEmptyStringValidator,
    notificationErrorIconName: nonEmptyStringValidator,
    notificationInfoIconName: nonEmptyStringValidator,
    notificationSuccessIconName: nonEmptyStringValidator,
    notificationWarningIconName: nonEmptyStringValidator,
    passwordInputHiddenIconName: nonEmptyStringValidator,
    passwordInputVisibleIconName: nonEmptyStringValidator,
    passwordRuleCheckerInitialIconName: nonEmptyStringValidator,
    passwordRuleCheckerInvalidIconName: nonEmptyStringValidator,
    passwordRuleCheckerSuccessIconName: nonEmptyStringValidator
});
